import { SignUpModal } from './SignUpModal'

export { SignUpModal }
export default SignUpModal
